import { Link } from "react-router-dom";
import { Footprints } from "lucide-react";
import { ARTICLES } from "@/data/articles";

export const Footer = () => {
  return (
    <footer className="border-t border-border bg-card">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground">
                <Footprints className="h-5 w-5" strokeWidth={2.5} />
              </span>
              <span className="font-heading text-xl font-bold tracking-tight text-foreground">
                Step<span className="text-primary">Zone</span>
              </span>
            </div>
            <p className="mt-3 max-w-xs font-body text-sm leading-relaxed text-muted-foreground">
              Take your next financial step. Choose what you'd like help with, and
              we'll send relevant resources — only on the channels you pick.
            </p>
          </div>

          <div>
            <p className="font-body text-xs font-semibold uppercase tracking-[0.15em] text-muted-foreground">
              Explore
            </p>
            <ul className="mt-4 space-y-2 font-body text-sm">
              <li><Link to="/" className="text-muted-foreground hover:text-primary">Get started</Link></li>
              <li><Link to="/blog" className="text-muted-foreground hover:text-primary">Useful Articles</Link></li>
              <li><Link to="/about" className="text-muted-foreground hover:text-primary">About</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-primary">Contact</Link></li>
            </ul>
          </div>

          <div>
            <p className="font-body text-xs font-semibold uppercase tracking-[0.15em] text-muted-foreground">
              Useful Articles
            </p>
            <ul className="mt-4 space-y-2 font-body text-sm">
              {ARTICLES.slice(0, 5).map((a) => (
                <li key={a.slug}>
                  <Link to={`/blog/${a.slug}`} className="text-muted-foreground hover:text-primary" data-testid={`footer-article-${a.slug}`}>
                    {a.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/blog" className="font-semibold text-primary hover:underline" data-testid="footer-all-articles">
                  View all articles →
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-body text-xs font-semibold uppercase tracking-[0.15em] text-muted-foreground">
              Legal
            </p>
            <ul className="mt-4 space-y-2 font-body text-sm">
              <li><Link to="/terms" className="text-muted-foreground hover:text-primary">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-muted-foreground hover:text-primary">Privacy Policy</Link></li>
              <li><Link to="/sms-terms" className="text-muted-foreground hover:text-primary">SMS Terms</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-border pt-6 font-body text-sm text-muted-foreground md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Step Zone. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <p>Not a lender, insurer, or financial advisor.</p>
            <Link to="/login" data-testid="footer-login" className="font-medium text-muted-foreground hover:text-primary">Login</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
